import React from 'react';
import { Platform, StyleSheet } from 'react-native';
import { Button as PaperButton } from 'react-native-paper';
import { theme, typeScale } from '../theme';
/**
 * Emulates the default React Native <Button>, but gives us
 * react-native-paper's loading indicator
 */
export const Button = ({ title, onPress, loading = false, disabled = false, buttonStyle = {}, textStyle = {}, width = undefined, style = undefined, }) => {
    const isDisabled = disabled || loading;
    return (<PaperButton mode="contained" onPress={!isDisabled ? onPress : undefined} loading={loading} disabled={isDisabled} contentStyle={[
            isDisabled ? styles.disabledButton : styles.enabledButton,
            buttonStyle,
        ]} labelStyle={[
            styles.labelStyle,
            isDisabled ? styles.disabledText : styles.enabledText,
            textStyle,
        ]} style={[styles.style, style ? style : {}, { width }]}>
      {title}
    </PaperButton>);
};
const styles = StyleSheet.create({
    style: {
        borderRadius: 0, // Rectangle shape
    },
    enabledButton: {
        backgroundColor: theme.colors.action,
    },
    disabledButton: {
        backgroundColor: theme.colors.buttonDisabledBackground,
    },
    // Native: Abbi Theme `button` role. Web admin keeps its 14pt label.
    labelStyle: Platform.OS === 'web'
        ? { fontSize: 14 }
        : {
            fontSize: typeScale.button.fontSize,
            lineHeight: typeScale.button.lineHeight,
            fontWeight: typeScale.button.fontWeight,
        },
    enabledText: {
        color: theme.colors.onAction,
    },
    disabledText: {
        color: theme.colors.controlDisabledStrong,
    },
});
